module.exports = __webpack_public_path__ + "__static/site-1768578553954/img/crocodile-star1.0a789355.png";